var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAskConcierge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13573_5244",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 114,
    height: 114
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H114V114H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13573_5244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0256 65.2574C75.7935 64.7291 82.742 57.4542 82.742 48.5533V18.4437C82.742 9.1995 75.248 1.70556 66.0038 1.70556H40.8145",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6625 1.7056H18.3974C9.15312 1.7056 1.65918 9.19954 1.65918 18.4438V48.5534C1.65918 57.7976 9.15312 65.2913 18.3974 65.2913L23.1569 70.0511C23.74 70.6342 24.6856 70.6342 25.269 70.0511L30.0285 65.2913H59.8769",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0527 36.0585C47.0527 38.7382 44.8805 40.9104 42.2008 40.9104C39.5214 40.9104 37.3491 38.7382 37.3491 36.0585C37.3491 33.3788 39.5214 31.2066 42.2008 31.2066C44.8805 31.2066 47.0527 33.3788 47.0527 36.0585Z",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3828 36.0585C26.3828 38.7382 24.2105 40.9104 21.5309 40.9104C18.8514 40.9104 16.6792 38.7382 16.6792 36.0585C16.6792 33.3788 18.8514 31.2066 21.5309 31.2066C24.2105 31.2066 26.3828 33.3788 26.3828 36.0585Z",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0171 36.0585C58.0171 38.7382 60.1893 40.9104 62.869 40.9104C65.5484 40.9104 67.7207 38.7382 67.7207 36.0585C67.7207 33.3788 65.5484 31.2066 62.869 31.2066C60.1893 31.2066 58.0171 33.3788 58.0171 36.0585Z",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2308 71.9712C43.8772 73.9455 43.6904 75.9777 43.6904 78.0537C43.6904 97.0064 59.0546 112.371 78.0071 112.371H97.1469C97.9535 112.371 98.4634 111.504 98.0713 110.799L96.0846 107.226C102.699 103.119 107.81 96.8241 110.415 89.3546",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.047 82.4119C112.228 80.9844 112.324 79.5302 112.324 78.0536C112.324 63.1029 102.762 50.3881 89.4209 45.6845",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9957 78.2171C81.9957 80.4199 80.21 82.2056 78.0072 82.2056C75.8043 82.2056 74.0186 80.4199 74.0186 78.2171C74.0186 76.0144 75.8043 74.2287 78.0072 74.2287C80.21 74.2287 81.9957 76.0144 81.9957 78.2171Z",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9942 78.2171C65.9942 80.4199 64.2085 82.2056 62.0058 82.2056C59.8028 82.2056 58.0171 80.4199 58.0171 78.2171C58.0171 76.0144 59.8028 74.2287 62.0058 74.2287C64.2085 74.2287 65.9942 76.0144 65.9942 78.2171Z",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0195 78.217C90.0195 80.4197 91.8052 82.2054 94.008 82.2054C96.2109 82.2054 97.9966 80.4197 97.9966 78.217C97.9966 76.0143 96.2109 74.2286 94.008 74.2286C91.8052 74.2286 90.0195 76.0143 90.0195 78.217Z",
    stroke: "#72879A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskConcierge);
export default __webpack_public_path__ + "static/media/ask-concierge.c6beb27cd5a74301b5f134a548020bab.svg";
export { ForwardRef as ReactComponent };